<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">伟嘉视角</span>
    </navbar>
    <div class="subbar-wrap" :class="{noTop: isWechat}">
      <ul class="subbar-father">
        <li :class="{active: selectSupTypeIndex === index}" v-for="(supType, index) in articleTypeArr" :key="supType.id" @click="changeArticleType(supType, index)">{{supType.name}}</li>
      </ul>
    </div>
    <div class="subbar-son" :class="{typeTop: isWechat}">
      <typebar
        :type-list="getSubType"
        :select-type-index="selectSubTypeIndex"
        @click-handler="clickSubType"
        :color="'#9CA5AE'"
        :activeColor="'#21507F'"
        :bd-color="'#129FDD'"/>
    </div>
    <div class="page-content" ref="pageContent" :class="{contentTop: isWechat}">
      <scroller ref="scroller" :on-infinite="loadMore">
        <div class="perspective">
          <ul class="list-group">
            <router-link tag="li" :to="`/perspective/article/${article.id}`" class="list-item clearfix" v-for="article in articleArr" :key="article.id">
              <span class="iconfont">&#xe695;</span>
              <p>{{article.title}}</p>
              <span class="time text-right">{{article.addDate}}</span>
            </router-link>
          </ul>
        </div>
      </scroller>
    </div>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Typebar from 'components/navbar/typebar'
  import Scroller from 'components/scroller/scroller'
  export default {
    data () {
      return {
        articleArr: [],
        pageNumber: 0,
        pageSize: 20,
        hasmore: true,
        typeId: null,
        articleTypeArr: [],
        selectSupTypeIndex: 0,
        selectSubTypeIndex: 0,
        isWechat: false,
        isLoadMore: false
      }
    },
    created () {
      this.getArticleType()
      if (this.$device.isWechat) {
        this.isWechat = true
      }
    },
    watch: {
      typeId () {
        this.$refs.scroller.loadingState = 0
        this.$refs.scroller.scrollTo(0, 0)
        this.$refs.pageContent.style.height = '-1px'
        this.articleArr = [].splice(0, this.articleArr.length)
        this.$refs.scroller.resize()
      }
    },
    computed: {
      getSubType () {
        if (this.articleTypeArr.length !== 0) {
          return this.articleTypeArr[this.selectSupTypeIndex || 0].sub
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.scrollerContent = this.$refs.pageContent.getElementsByClassName('scroller-content')[0]
        setTimeout(() => {
          this.$refs.scroller.resize()
        }, 500)
      })
    },
    methods: {
      getArticleType () {
        let vm = this
        this.$ajax({
          url: '/getWJViewArticleType.jhtml',
          done (typeList) {
            vm.articleTypeArr = [].concat(typeList)
            vm.typeId = vm.articleTypeArr[0].sub[0].id
            vm.isLoadMore = true
          }
        })
      },
      getArticlesByType () {
        let vm = this
        this.$ajax({
          url: '/getWJViewArticles.jhtml',
          params: {
            typeId: this.typeId,
            isPage: 'y',
            pageNumber: this.pageNumber || 1,
            pageSize: this.pageSize
          },
          done (result, page) {
            vm.pageNumber = page.pageNumber
            vm.hasmore = page.count > 0 && page.pageNumber * page.pageSize < page.count
            vm.articleArr = vm.articleArr.concat(result)
//            if (vm.hasmore) {
//              vm.$refs.scroller.finishInfinite(false)
//            } else {
//              vm.$refs.scroller.finishInfinite(true)
//            }
          },
          fail (msg) {
            vm.$dialog(msg)
          },
          always () {
//            if (vm.scrollerContent) {
//              vm.scrollerContent.style.transform = 'translate3d(0, 0, 0)'
//              vm.$refs.scroller.resize()
//            }
            vm.$refs.scroller.finishInfinite(true)
          }
        })
      },
      clickSubType (item, index) {
        if (this.selectSupTypeIndex == null) {
          this.selectSupTypeIndex = 0
        }
        this.hasmore = true
        this.pageNumber = 0
        this.typeId = item.id
        this.selectSubTypeIndex = index
      },
      changeArticleType (item, index) {
        this.hasmore = true
        this.pageNumber = 0
        this.selectSupTypeIndex = index
        this.selectSubTypeIndex = 0
        this.typeId = item.sub[0].id
      },
      loadMore () {
        if (this.isLoadMore) {
          if (this.hasmore) {
            this.pageNumber++
            setTimeout(() => {
              this.getArticlesByType()
            }, 500)
          } else {
            this.$refs.scroller.finishInfinite(true)
          }
        }
      }
    },
    components: {
      Navbar,
      Typebar,
      Scroller
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'
  .navbar
    height px2rem(88px)
    &.navbar-fixed
      & ~ .page-content
        top px2rem(260px)
        padding-top px2rem(12px)
        background-color rgba(255, 255, 255, 0.4)
  .subbar-wrap
    position relative
    left 0
    right 0
    bottom 0
    top px2rem(88px)
    .subbar-father
      margin 0
      padding 0
      position absolute
      top 0
      left 0
      right 0
      z-index 100
      height px2rem(88px)
      line-height px2rem(88px)
      box-shadow 0 0 10px rgba(39,84,130,.75)
      font-size 0
      background url("../../../static/images/bg-consultor.jpg") no-repeat top left
      background-size 100% auto
      li
        width 33.3333%
        display inline-block
        list-style none
        font-size px2rem(30px)
        color #CFDAE6
        text-align center
        &.active
          color #fff
          font-weight bold
  .subbar-son
    position absolute
    left 0
    right 0
    bottom 0
    z-index 100
    top px2rem(176px)
    height px2rem(84px)
    background-color #fff
    box-shadow 0 2px 6px 0 rgba(171,185,197,1)

  .list-group
    padding 0
    margin 0
    .list-item
      list-style none
      padding 0 px2rem(20px)
      border-bottom 1px dotted #275482
      height px2rem(84px)
      line-height px2rem(84px)
      .iconfont
        font-size px2rem(20px)
        color #25A6DD
        float left
      p
        float left
        margin 0
        margin-left 2px
        width px2rem(400px)
        color #275482
        font-size px2rem(24px)
        ellipsis()
      .time
        float right
        color #275482
        font-size px2rem(20px)
  .noTop
    top 0
  .typeTop
    top px2rem(88px)
  .contentTop
    top px2rem(172px)
</style>



// WEBPACK FOOTER //
// perspective.vue?fb2327ae